import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=7b8bd09b&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"
import style0 from "./tabs.vue?vue&type=style&index=0&id=7b8bd09b&prod&lang=css"
import style1 from "./tabs.vue?vue&type=style&index=1&id=7b8bd09b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8bd09b",
  null
  
)

export default component.exports